import { render, staticRenderFns } from "./modal-statement.vue?vue&type=template&id=13ae7d8a&scoped=true&"
import script from "./modal-statement.vue?vue&type=script&lang=js&"
export * from "./modal-statement.vue?vue&type=script&lang=js&"
import style0 from "./modal-statement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./modal-statement.vue?vue&type=style&index=1&id=13ae7d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae7d8a",
  null
  
)

export default component.exports